module.exports = __webpack_public_path__ + "img/HISToRIA.247b6b66.png";